import { ReactNode } from "react";
import Box from "@mui/joy/Box";

import { FOOTER_HEIGHT } from "../constants";

export const XsFooter = (props: { children?: ReactNode; sx?: any }) => {
  return (
    <Box
      {...props}
      sx={[
        {
          p: 0,
          m: 0,
          // bgcolor: colors.white,
          bgcolor: "atomic.grey1",
          display: {
            xs: "initial",
            sm: "none",
          },
          gridRow: 2,
          gridColumn: 1,
          height: FOOTER_HEIGHT,
          overflow: "hidden",
          // borderTop: `2px solid ${colors.black100}`,
          borderTop: `2px solid black`,
          borderTopColor: `atomic.grey2`,
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
      aria-label="xs-footer"
    />
  );
};
